//NEW: UI_REVAMP
import { Flex, Text } from '@chakra-ui/react';
import { currencyFormat } from '../../utils/numberFormat';

const PriceText = ({
	price,
	priceFontSize = { base: '16px', lg: '12px' },
	currencyFontSize = { base: '10px', lg: '8px' },
	color = 'white',
	fontWeight = 600,
}) => {
	return (
		<Flex alignItems='baseline' color={color} fontWeight={fontWeight} gap={0.5}>
			<Text fontSize={priceFontSize}>{currencyFormat(Number(price))}</Text>

			<Text as='span' fontSize={currencyFontSize}>
				₱
			</Text>
		</Flex>
	);
};

export default PriceText;
